import React from 'react'
import styled from '@emotion/styled'

export const H5 = styled.h5`
`

export default H5